










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'PathErrorPanel',

})
export default class PathErrorPanel extends Vue {
  @Prop() private startName: string;
  @Prop() private endName: string;
  @Prop() private typeTabName: string;
  constructor() {
      super();
  }
  public created() {
  }

  public mounted() {
  }
}
